import { css } from '@emotion/react';

export const wrapper = () =>
  css({
    margin: 'auto',
  });
